import PatientMoviment from "@/views/patient_moviment/patient_moviment.vue";

export default [
  {
    path: "movimentacao-paciente",
    name: "Movimentação do Paciente",
    component: PatientMoviment,
  },
];
